import React from "react";
import { Container, Row, Col, Card, Accordion, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// import screenshots for Usage
import reports1 from "../../assets/img/docs/reports-1.png";
import reports2 from "../../assets/img/docs/reports-2.png";
import reports3 from "../../assets/img/docs/reports-3.png";
import reports4 from "../../assets/img/docs/reports-4.png";
import reports5 from "../../assets/img/docs/reports-5.png";
import reports6 from "../../assets/img/docs/reports-6.png";
import reports7 from "../../assets/img/docs/reports-7.png";

// import screenshots for Invoice List
import reportsInvoice1 from "../../assets/img/docs/reports-8.png";
import reportsInvoice2 from "../../assets/img/docs/reports-9.png";

import reportsOrders1 from "../../assets/img/docs/reports-10.png";
import reportsOrders2 from "../../assets/img/docs/reports-11.png";

import reportPortfolioActivity from "../../assets/img/docs/reports-12.png";

import reportCustomerSimSessions from "../../assets/img/docs/reports-13.png";

import reportSimOverview from "../../assets/img/docs/reports-14.png";

import reportSimList from "../../assets/img/docs/reports-15.png";

import reportExportToFile from "../../assets/img/docs/reports-16.png";

const Section = ({
  eventKey,
  title,
  description,
  bullets = [],
  images = [],
}) => (
  <Accordion.Item
    eventKey={eventKey}
    className="mb-3 border-0 shadow-sm rounded section-item"
  >
    <Accordion.Header className="fw-semibold fs-6">{title}</Accordion.Header>
    <Accordion.Body className="pt-3 section-body">
      {description && <p className="mb-3 text-muted">{description}</p>}

      {bullets?.length > 0 && (
        <ul className="section-list mb-3">
          {bullets.map((b, i) => (
            <li key={i} className="mb-2">
              {b}
            </li>
          ))}
        </ul>
      )}

      {images?.length > 0 && (
        <Row className="g-3 mt-2">
          {images.map(
            (src, i) =>
              src && (
                <Col md={6} key={i}>
                  <Image
                    src={src}
                    alt={`${title} screenshot ${i + 1}`}
                    className="section-image"
                    rounded
                    fluid
                  />
                </Col>
              )
          )}
        </Row>
      )}
    </Accordion.Body>
  </Accordion.Item>
);

const SingleReport = () => {
  const { t } = useTranslation();

  const sections = [
    // Usage Report
    { key: "howToAccess", images: [reports1] },
    {
      key: "usageReport",
      images: [reports2, reports3, reports4, reports5, reports6, reports7],
    },
    // Invoice List
    {
      key: "invoiceList",
      images: [reportsInvoice1, reportsInvoice2], // merged screenshots
    },
    {
      key: "orders",
      images: [reportsOrders1, reportsOrders2],
    },
    {
      key: "portfolioActivity",
      images: [reportPortfolioActivity],
    },
    {
      key: "customerSimSessions",
      images: [reportCustomerSimSessions],
    },
    {
      key: "simOverview",
      images: [reportSimOverview],
    },
    {
      key: "simList",
      images: [reportSimList],
    },
    {
      key: "exportReport",
      images: [reportExportToFile],
    },
    {
      key: "timeoutReports",
      images: [],
    },
  ];

  return (
    <Container fluid className="py-5 single-report-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              <Card.Title className="display-6 mb-3">
                {t("documentation.reports.single.title")}
              </Card.Title>
              <Card.Text className="text-muted mb-3">
                {t("documentation.reports.single.description")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col lg={10}>
          <Card className="shadow-sm border-0 rounded-lg p-3">
            <Accordion defaultActiveKey="0" alwaysOpen>
              {sections.map((s, idx) => {
                const bullets = t(
                  `documentation.reports.single.${s.key}.bullets`,
                  { returnObjects: true, defaultValue: [] }
                );

                return (
                  <Section
                    key={s.key}
                    eventKey={String(idx)}
                    title={t(`documentation.reports.single.${s.key}.title`, "")}
                    description={t(
                      `documentation.reports.single.${s.key}.description`,
                      ""
                    )}
                    bullets={Array.isArray(bullets) ? bullets : []}
                    images={s.images}
                  />
                );
              })}
            </Accordion>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SingleReport;
